import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { priceWithCurrency } from "../../../actions/functions";
import {
  IFullProject,
  ProductVariant,
  StandardProductData,
  StandardProjectData
} from "../../../actions/types";
import { setShowModal } from "../catalog/catalogSlice";
import Variants from "../variants/Variants";
import { selectVariant } from "./productSlice";

declare function prefixURL(url: string): string;

export interface RightPanelStandaloneProductProps {
  directSellingDomain: boolean;
  isCatalog: boolean;
  product: IFullProject;
  sibling_product: IFullProject;
  price_diff: number;
  currencySymbol: string;
  url: string;
  addUrl: string;
  plannerAllowed: boolean;
  plannerUrl: string;
  standaloneProduct: boolean;
}

export interface TransportCostParams {
  weight: number | null;
  palette_count: number | null;
  length_dm: number | null;
}

declare function prefixURL(url: string): string;

// @ts-ignore
const csrf = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");

const RightPanelStandaloneProduct = (
  props: RightPanelStandaloneProductProps
) => {
  const dispatch = useDispatch();
  const [productPrice, setProductPrice] = useState<number>(0),
    [basicProductPrice, setBasicProductPrice] = useState<number>(0),
    [productVariants, setProductVariants] = useState<ProductVariant[]>([]),
    [productQty, setProductQty] = useState<number>(1),
    [vatTax, setVatTax] = useState(0),
    [vat, setVat] = useState(0),
    [showVat, setShowVat] = useState(false),
    [showTransport, setShowTransport] = useState(false),
    [transportParams, setTransportParams] = useState<TransportCostParams>({
      weight: props.product.weight,
      palette_count: props.product.palette_count,
      length_dm: props.product.length_dm,
    }),
    variant: ProductVariant | undefined = useSelector(selectVariant),
    clickPlusMinusQty = (type: "plus" | "minus") => {
      if (type === "minus" && productQty - 1 <= 0) {
        return;
      }
      if (type === "plus") {
        setProductQty((qty) => qty + 1);
      } else {
        setProductQty((qty) => qty - 1);
      }
    },
    setIsOpen = (state: boolean) => {
      dispatch(setShowModal(state));
    };

  useEffect(() => {
    Axios.get<StandardProjectData & StandardProductData>(props.url, {
      headers: {
        accept: "application/json",
        "X-CSRF-Token": csrf,
      },
    })
      .then((res) => {
        setBasicProductPrice(Number(res.data.price));
        setProductPrice(Number(res.data.price));
        setVatTax(Number(res.data.vat_tax));
        setVat(Number(res.data.price_vat));
        setShowVat(res.data.show_vat);
        setShowTransport(res.data.show_transport);
        if (res.data.variants) {
          setProductVariants(res.data.variants.filter((variant) => Number(variant.price) > 0));
        }
      })
      .catch((err) => console.log("ERR: ", err));
  }, []);

  useEffect(() => {
    let newPrice = basicProductPrice;
    let variantSum = 0;
    if (variant) {
      variantSum = Number(variant.price);
      setVat(Number(variant.price_vat))
    }
    setProductPrice((newPrice + variantSum) * productQty);
  }, [productQty, variant]);

  const variantName = variant ? variant.label : null;

  const showVatPrice = !!showVat;
  if (props.isCatalog) {
    return (
      <>
        <div className="product__sidebar">
          <h1>{props.product.name}</h1>
          {!!variantName && <h2>{variantName}</h2>}
          <ul className="product__sidebar-list">
            <li>
              {I18n.t("shop.product_no")}: {props.product.id}{" "}
            </li>
          </ul>
          <input
            type="button"
            value={I18n.t("shop.check_the_price")}
            className="btn btn--ultrablue btn-block text-center"
            onClick={() => setIsOpen(true)}
          />
          <Variants
            isCatalog={props.isCatalog}
            product_id={props.product.id}
            variants={productVariants}
          />
        </div>
        {/* <% end %> */}
      </>
    );
  } else {
    return (
      <>
        <div className="product__sidebar">
          <div id="floating_price" className="d-none">
            <div className="">
              <span className="">{I18n.t("shop.cabin_price")}: </span>
              <span className="">
                {priceWithCurrency(productPrice, props.currencySymbol)}
              </span>
            </div>
          </div>
          <h1>{props.product.name}</h1>
          {!!variantName && <h2>{variantName}</h2>}
          <div className="product__price-row">
            <span className="product__price-label">
              {I18n.t("shop.cabin_price")}
            </span>
            <span className="product__price">
              {priceWithCurrency(productPrice, props.currencySymbol)}
            </span>
          </div>
          {showVatPrice && (
            <div className="product__vat-row">
              <span className="product__vat-label">
                ({I18n.t("shop.include_vat")} {I18n.t("shop.vat")})
              </span>
              <span className="product__vat">
                {priceWithCurrency(productQty * vat, props.currencySymbol)}
              </span>
            </div>
          )}
          {/* {showTransport && (
            <div className="product__transport-cost-row">
              <span className="product__transport-cost-label">
                {I18n.t("shop.transport_cost")}:
              </span>
              <span className="product__transport-cost">
                <TransportCost
                  directSellingDomain={props.directSellingDomain}
                  transportParams={transportParams}
                  currency={props.currencySymbol}
                />
              </span>
            </div>
          )} */}
          <form
            action={prefixURL(props.addUrl)}
            acceptCharset="UTF-8"
            method="post"
          >
            <input type="hidden" name="authenticity_token" value={csrf || ""} />
            <input type="hidden" value={props.product.id} name="standalone_product[id]" />
            <div className="product__controls-row d-flex flex-row-reverse">
              <div className="cart__qty-col">
                <div className="form-group">
                  <div className="quantity quantity-lg">
                    <input
                      type="button"
                      value="-"
                      className="minus btn"
                      onClick={() => clickPlusMinusQty("minus")}
                    />
                    <input
                      value={productQty}
                      onChange={(e) => setProductQty(+e.target.value)}
                      name="standalone_product[quantity]"
                      type="number"
                      min="1"
                      className="form-control cart__qty-input"
                      title={I18n.t("shop.quantity")}
                    />
                    <input
                      type="button"
                      value="+"
                      className="plus btn"
                      onClick={() => clickPlusMinusQty("plus")}
                    />
                  </div>
                </div>
              </div>
            </div>

            <ul className="product__sidebar-list">
              <li>
                {I18n.t("shop.product_no")}: {props.product.id}{" "}
              </li>
            </ul>

            <div className="product__sidebar-btns">
              <input
                type="submit"
                name="commit"
                value={I18n.t("shop.buy")}
                data-disable-with={I18n.t("shop.buy")}
                className="btn btn--ultrablue btn-block text-center"
              />
            </div>

            <Variants
              isCatalog={props.isCatalog}
              product_id={props.product.id}
              variants={productVariants}
            />
          </form>
        </div>
        {/* <% end %> */}
      </>
    );
  }
};

export default RightPanelStandaloneProduct;
